// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"2a082f4d","488":"108662f3","977":"329388f3"}[chunkId] + ".chunk.js";
};